import type { RawMaterialKind } from "@artisancode/api-types";

export type StockItemType = "raw_material" | "product";
export type StockStatus = "in_stock" | "low_stock" | "out_of_stock";

export interface StockItem {
  id: string;
  itemId: string;
  name: string;
  sku?: string | null;
  type: StockItemType;
  kind?: RawMaterialKind | null;
  categoryName: string;
  uomName: string;
  onHandQty: number;
  repackingQty: number;
  riderQty: number;
  currentStock: number;
  minStock: number;
  costPerUnit: number;
  totalValue: number;
  status: StockStatus;
  notes?: string | null;
}

export const STOCK_STATUS_CONFIG: Record<
  StockStatus,
  {
    label: string;
    badgeVariant: "default" | "secondary" | "destructive" | "outline";
    className?: string;
    /** Tone for the total-stock number. */
    qtyClassName: string;
    /** Highlight for the item's card (mobile) / row (desktop). */
    cardClassName?: string;
    rowClassName?: string;
  }
> = {
  in_stock: {
    label: "Aman",
    badgeVariant: "outline",
    className:
      "bg-emerald-500/10 text-emerald-600 border-emerald-500/30 font-medium",
    qtyClassName: "text-foreground",
  },
  low_stock: {
    label: "Menipis",
    badgeVariant: "secondary",
    className:
      "bg-amber-500/15 text-amber-700 dark:text-amber-400 border border-amber-500/30 font-medium",
    qtyClassName: "text-amber-600 dark:text-amber-400",
    cardClassName: "border-amber-500/40 bg-amber-500/5",
    rowClassName: "bg-amber-500/5 hover:bg-amber-500/10",
  },
  out_of_stock: {
    label: "Habis (0)",
    badgeVariant: "destructive",
    className: "font-medium",
    qtyClassName: "text-destructive",
    cardClassName: "border-destructive/40 bg-destructive/5",
    rowClassName: "bg-destructive/5 hover:bg-destructive/10",
  },
};

export const STOCK_TYPE_LABELS: Record<StockItemType, string> = {
  raw_material: "Bahan Baku",
  product: "Produk Siap Jual",
};
